import { apiFetch } from "@/lib/api";

export type PickupStatus = "REQUESTED" | "CONFIRMED" | "READY" | "COLLECTED" | "DECLINED";
export type PickupWindow = {
  id: string; location: string; startsAt: string; endsAt: string; capacity: number; remaining: number; active: boolean;
};
export type PickupChoice = { pickupWindowId?: string; pickupRequestedAt?: string; pickupNote?: string };
export type PickupPage = { items: PickupWindow[]; page: number; size: number; totalPages: number; totalElements: number };
export type PickupSchedule = {
  id: string; location: string; daysOfWeek: number[]; startTime: string; endTime: string; timezone: string;
  capacity: number; horizonWeeks: number; appointmentNote: string | null; active: boolean;
};
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const pickupLabels: Record<PickupStatus, string> = {
  REQUESTED: "Awaiting confirmation", CONFIRMED: "Scheduled", READY: "Ready for pickup", COLLECTED: "Collected", DECLINED: "Requested time unavailable",
};
export function listPickupWindows(page = 0, admin = false) {
  return apiFetch<PickupPage>(admin ? "/admin/pickups" : "/pickup-windows", { params: { page, size: 20 } });
}
export function createPickupWindow(value: { location: string; startsAt: string; endsAt: string; capacity: number }) {
  return apiFetch<PickupWindow>("/admin/pickups", { method: "POST", body: JSON.stringify(value) });
}
export function closePickupWindow(id: string) {
  return apiFetch<void>(`/admin/pickups/${id}`, { method: "DELETE" });
}
export function listPickupSchedules(admin = false) {
  return apiFetch<PickupSchedule[]>(admin ? "/admin/pickup-schedules" : "/pickup-schedules");
}
export function savePickupSchedule(schedule: Partial<PickupSchedule> & { location: string; daysOfWeek: number[]; startTime: string; endTime: string }) {
  return apiFetch<PickupSchedule>(schedule.id ? `/admin/pickup-schedules/${schedule.id}` : "/admin/pickup-schedules", {
    method: schedule.id ? "PUT" : "POST",
    body: JSON.stringify(schedule),
  });
}
export function deletePickupSchedule(id: string) {
  return apiFetch<void>(`/admin/pickup-schedules/${id}`, { method: "DELETE" });
}
export type SkippedPickupDay = { id: string; location: string; startsAt: string; endsAt: string };
export function listSkippedDays(scheduleId: string) {
  return apiFetch<SkippedPickupDay[]>(`/admin/pickup-schedules/${scheduleId}/skipped`);
}
export function skipPickupDay(scheduleId: string, date: string) {
  return apiFetch<SkippedPickupDay>(`/admin/pickup-schedules/${scheduleId}/skipped`, { method: "POST", body: JSON.stringify({ date }) });
}
export function reopenPickupDay(scheduleId: string, windowId: string) {
  return apiFetch<void>(`/admin/pickup-schedules/${scheduleId}/skipped/${windowId}`, { method: "DELETE" });
}
export function updatePickup(id: string, status: PickupStatus) {
  return apiFetch<void>(`/admin/pickups/orders/${id}`, { method: "PUT", body: JSON.stringify({ status }) });
}
export function pickupTime(value: string) {
  return new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
